import { createSlice } from "@reduxjs/toolkit";
import { updatePackage } from "../thunks/updatePackageThunk";

const updatePackageSlice = createSlice({
  name: "package",
  initialState: {
    status: "idle", // 'idle' | 'loading' | 'success' | 'error'
    error: null,
    package: null,
  },
  reducers: {
    resetUpdatePackageStatus: (state) => {
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updatePackage.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updatePackage.fulfilled, (state, action) => {
        state.package = action.payload;
        state.status = "success";
        state.error = null;
      })
      .addCase(updatePackage.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload;
      });
  },
});

export const { resetUpdatePackageStatus } = updatePackageSlice.actions;
export default updatePackageSlice.reducer;
